module.exports = __webpack_public_path__ + "img/documents-illustration.65dadcb0.svg";